import React__default from 'react';
import MessageBubble from '../../MessageBubble/index.js';
import styles from './styles.css.js';

var ErrorMessage = function ErrorMessage(_a) {
  var message = _a.message;
  return React__default.createElement(MessageBubble, {
    message: message,
    className: styles.errorMessage
  }, "Unrecognized message type");
};

ErrorMessage.handlesMessage = function () {
  return true;
};

export default ErrorMessage;
//# sourceMappingURL=index.js.map
